module.exports = __webpack_public_path__ + "static/media/twisto.86eee427.jpg";